!function t(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], r) : "object" == typeof exports ? exports.BxTooltip = r(require("react"), require("react-dom")) : e.BxTooltip = r(e.React, e.ReactDOM);
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function e() {
        return t.default;
      } : function e() {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "./dist/", r(r.s = 3);
  }([function (e, r) {
    e.exports = t;
  }, function (t, e, r) {}, function (t, r) {
    t.exports = e;
  }, function (t, e, r) {
    r(1), t.exports = r(4);
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = r(0),
        o = r.n(n),
        i = r(2),
        c = r.n(i),
        u = r(1),
        f = r.n(u);

    function a(t) {
      return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function t(e) {
        return typeof e;
      } : function t(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(t);
    }

    function l(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function p(t, e, r) {
      return e && l(t.prototype, e), r && l(t, r), t;
    }

    function s(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && y(t, e);
    }

    function y(t, e) {
      return (y = Object.setPrototypeOf || function t(e, r) {
        return e.__proto__ = r, e;
      })(t, e);
    }

    function b(t) {
      var e = O();
      return function r() {
        var n = v(t),
            o;

        if (e) {
          var i = v(this).constructor;
          o = Reflect.construct(n, arguments, i);
        } else o = n.apply(this, arguments);

        return d(this, o);
      };
    }

    function d(t, e) {
      return !e || "object" !== a(e) && "function" != typeof e ? h(t) : e;
    }

    function h(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function O() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function v(t) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function t(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(t);
    }

    function m(t, e) {
      if (null == t) return {};
      var r = j(t, e),
          n,
          o;

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (o = 0; o < i.length; o++) {
          n = i[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
        }
      }

      return r;
    }

    function j(t, e) {
      if (null == t) return {};
      var r = {},
          n = Object.keys(t),
          o,
          i;

      for (i = 0; i < n.length; i++) {
        o = n[i], e.indexOf(o) >= 0 || (r[o] = t[o]);
      }

      return r;
    }

    function g() {
      return (g = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function P(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? P(Object(r), !0).forEach(function (e) {
          x(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : P(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function x(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function S(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    var _ = 0,
        R = function t(e) {
      S(this, t);
      var r = this;
      this.uid = _++, this.id = "bx-tooltip-".concat(this.uid), this.chartIns, this.Chart = function (t) {
        return o.a.createElement(e, g({}, t, {
          onGetG2Instance: function e(n) {
            r.chartIns = n, n.tooltip(!0, w({
              useHtml: !0,
              offset: 20,
              containerTpl: '<div id="'.concat(r.id, '" class="g2-tooltip bx-tooltip" ></div>')
            }, r.tooltipConfig)), n.on("tooltip:change", function (t) {
              var e = t.items,
                  n = "";
              e.length && (n = e[0].title), r.reRender({
                title: n,
                items: e
              });
            }), t.onGetG2Instance && t.onGetG2Instance(n), n.repaint();
          }
        }));
      }, this.Tooltip = function (t) {
        var e = t.children,
            n = m(t, ["children"]);
        return r.tooltipConfig = n, o.a.createElement(E, {
          refChart: r,
          contentFill: e
        });
      };
    },
        E = function (t) {
      s(r, t);
      var e = b(r);

      function r(t) {
        var n, i;
        return S(this, r), (n = e.call(this, t)).content = o.a.createRef(), n.reRender = function (t) {
          var e = h(n),
              r = n.props.contentFill,
              i = document.querySelector("#".concat(n.props.refChart.id));
          i && i.addEventListener("mouseenter", function (t) {
            t.stopPropagation(), i.style.display = "block";
          }), i && i.parentNode && i.parentNode.addEventListener("mouseleave", function (t) {
            t.stopPropagation();
            var r = e.props.refChart.chartIns;
            r && r.hideTooltip();
          });
          var u = "";

          if ("function" == typeof r) {
            var f = t.title,
                a = t.items;
            f && a && (u = n.props.contentFill(t.title, t.items));
          } else u = n.props.contentFill;

          i && c.a.render(o.a.createElement("div", null, u), i);
        }, t.refChart.reRender = n.reRender, n;
      }

      return p(r, [{
        key: "render",
        value: function t() {
          return null;
        }
      }]), r;
    }(o.a.Component),
        C = function t(e, r) {
      var n = new R(e, r);
      return [n.Chart, n.Tooltip];
    };

    C.create = C, e.default = C;
  }]);
});